@if (searchMessage.message) {
  <div class="pb-5">
    <p class="text-sm" [innerHTML]="searchMessage.message | linkify"></p>
    @if (searchMessage.totalCount) {
      <p class="text-sm"><b>{{'searchResult.totalCount'| translate}}:</b> {{searchMessage.totalCount}}</p>
    }
  </div>
}
@if (!searchMessage.message) {
  <p class="pb-5 text-sm" [innerHTML]="'searchResult.info' | translate : {totalResult : searchMessage.totalCount}"></p>
}
@if (searchMessage.searchResultItems && searchMessage.searchResultItems.length>0) {
  <div class="table-container text-sm">
    <p-table [resizableColumns]="true" columnResizeMode="expand"  [value]="searchMessage.searchResultItems">
      <ng-template #header>
        <tr>
          <th pResizableColumn>{{ 'searchResult.headers.tenantId' | translate }}</th>
          <th pResizableColumn>{{ 'searchResult.headers.licenseName' | translate }}</th>
          <th pResizableColumn>{{ 'searchResult.headers.tenant' | translate }}</th>
          <th pResizableColumn>{{ 'searchResult.headers.purchaser' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template #body let-searchItem>
        <tr (click)="openLicense(searchItem.microsoftTenantID)" class="hover:bg-gray-100 dark:hover:bg-gray-900 cursor-pointer">
          <td>
            <span class="p-column-title">{{ "searchResult.headers.tenantId" | translate }}</span>
            <span class="truncate hover:text-clip w-full" [title]="searchItem.microsoftTenantID">
              {{ searchItem.microsoftTenantID }}
            </span>
          </td>
          <td>
            <span class="p-column-title">{{ "searchResult.headers.licenseName" | translate }}</span>
            <span class="truncate hover:text-clip w-full table-col-primary" [title]="searchItem.editionName">
              {{ searchItem.editionName }}
            </span>
          </td>
          <td>
            <span class="p-column-title">{{ "searchResult.headers.tenant" | translate }}</span>
            <span class="truncate hover:text-clip w-full" [title]="searchItem.ownerCompanyName">
              {{ searchItem.ownerCompanyName }}
            </span>
          </td>
          <td>
            <span class="p-column-title">{{ "searchResult.headers.purchaser" | translate }}</span>
            <span class="truncate hover:text-clip w-full" [title]="searchItem.ownerName">
              {{ searchItem.ownerName }}
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}
